import { jsPDF } from 'jspdf';

import { CuripodElement } from '../../components/SlideComponents/slateUtil';
import renderParagraph from './renderParagraph';
import { setPdfTextStyling } from './renderUtils';

type RenderNumberedListProps = {
  pdf: jsPDF;
  numberedListElement: CuripodElement;
  x: number;
  y: number;
  width: number;
  scale: number;
};

const renderNumberedList = async ({
  pdf,
  x,
  y,
  width,
  numberedListElement,
  scale,
}: RenderNumberedListProps) => {
  const currentX = x;
  let currentY = y;
  if (!numberedListElement.children || !Array.isArray(numberedListElement.children))
    return { updatedY: currentY };

  setPdfTextStyling({
    pdf,
    color: '#000', //black
    bold: false,
    italic: false,
  });
  const threeDigitNumberSample = '888.';
  const numberSectionLeftPadding = pdf.getTextDimensions(threeDigitNumberSample).w;
  const numberSectionRightPadding = numberSectionLeftPadding * 0.1;

  for (const [
    index,
    eachListItem,
  ] of (numberedListElement.children as CuripodElement[]).entries()) {
    setPdfTextStyling({
      pdf,
      color: '#000', //black
      bold: false,
      italic: false,
    });

    const numberingChars = `${index + 1}.`;
    const numberingCharsWidth = pdf.getTextDimensions(numberingChars).w;
    const numberingCharsHeight = pdf.getTextDimensions(numberingChars).h;

    pdf.text(
      numberingChars,
      currentX + numberSectionLeftPadding - numberingCharsWidth,
      currentY + numberingCharsHeight,
    );

    // list-item can either contain a paragraph child OR have text children directly
    const firstChild = eachListItem.children?.[0] as CuripodElement | undefined;
    const paragraphElement = firstChild?.type === 'paragraph' ? firstChild : eachListItem;

    const { updatedY } = await renderParagraph({
      pdf,
      x: currentX + numberSectionLeftPadding + numberSectionRightPadding,
      y: currentY,
      width: width - numberSectionLeftPadding + numberSectionRightPadding,
      paraElement: paragraphElement,
      scale,
    });
    currentY = updatedY;
  }

  return { updatedY: currentY };
};

export default renderNumberedList;
